import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';

interface TooltipContextType {
  isTooltipOpen: boolean;
  setIsTooltipOpen: Dispatch<SetStateAction<boolean>>;
}

const TooltipContext = createContext<TooltipContextType>({
  isTooltipOpen: false,
  setIsTooltipOpen: () => {},
});

export const TooltipProvider = ({ children }: { children: ReactNode }) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const value = useMemo(
    () => ({
      isTooltipOpen,
      setIsTooltipOpen,
    }),
    [isTooltipOpen],
  );

  return <TooltipContext.Provider value={value}>{children}</TooltipContext.Provider>;
};

export const useTooltip = () => useContext(TooltipContext);
